import { Injectable } from "@angular/core";
import { ConnectionServices } from "../authentication/connection/connection.service";
import { IdentityService } from "../authentication/identity.service";
import { catchError, map, Observable, of, throwError } from "rxjs";
import { GetDashboardAdminCommand, IGetDashboardAdminCommandParameters, IGetDashboardCommandResponse } from "./command/getDashboardAdminCommand";


@Injectable()
export class AdminService {
  private titleMessage: string;

  constructor(
      private _connectionService: ConnectionServices,
    //   private _notificationsService: NotificationsService,
    //   private _multiRegionService: MultiRegionService,
      public _identityService: IdentityService
  ) {
    // this.titleMessage = this._multiRegionService.getLabel(
    //     AdminDashboardEnum.ADMIN_DASHBOARD_TITLE_MESSAGE
    // );
  }

//   public getAdminsList(
//       page: number,
//       size: number,
//       column: string,
//       sort: SortEnum,
//       termToSearch: string
//   ): Observable<AdminsGrid> {
//     const command = new GetAdminsCommand();
//     command.setParameters(<IGetAdminsCommandParameters>{
//       column: column,
//       page: page,
//       size: size,
//       sort: sort,
//       termToSearch: termToSearch
//     });
//     return this._connectionService
//         .Request(command)
//         .map(data => {
//           const response = data as AdminsGrid;
//           return response;
//         })
//         .catch(() => {
//           return Observable.throw(false);
//         });
//   }

//   public addAdmin(admin: AdminRequestDto): Observable<AdminResponseDTO> {
//     const command = new AddAdminCommand();
//     command.setParameters(<IAddAdminCommandParameters>{
//       country: admin.country,
//       adminType: admin.adminType,
//       email: admin.email,
//       firstName: admin.firstName,
//       lastName: admin.lastName,
//       timezone: admin.timezone
//     });
//     return this._connectionService
//         .Request(command)
//         .map(data => {
//           return data;
//         })
//         .catch(error => {
//           if (
//               error.error.errorCode !== undefined &&
//               error.error.errorCode !== null &&
//               error.error.errorCode !== 'undefined'
//           ) {
//             if (error.error.errorCode === ErrorsEnum.MAIL_UNIQUE) {
//               this._notificationsService.showInternalErrorMessage(
//                   'toast.admin.admin',
//                   'toast.admin.email_in_use'
//               );
//             }
//           } else {
//             this._notificationsService.showHttpErrorMessage('Admin', error);
//           }
//           return Observable.throw(false);
//         });
//   }

//   public putAdmin(
//       admin: AdminRequestDto,
//       adminUserId: number
//   ): Observable<AdminResponseDTO> {
//     const command = new UpdateAdminCommand();
//     command.setParameters(<IUpdateAdminCommandParameters>{
//       adminUserId: adminUserId,
//       country: admin.country,
//       adminType: admin.adminType,
//       email: admin.email,
//       firstName: admin.firstName,
//       lastName: admin.lastName,
//       timezone: admin.timezone
//     });
//     return this._connectionService
//         .Request(command)
//         .map(data => {
//           return data;
//         })
//         .catch(() => {
//           return Observable.throw(false);
//         });
//   }

//   public getById(adminId: number): Observable<AdminResponseDTO> {
//     const command = new GetAdminByIdCommand();
//     command.setParameters(<IGetAdminByIdCommandParameters>{
//       adminUserId: adminId
//     });
//     return this._connectionService
//         .Request(command)
//         .map(data => {
//           return data;
//         })
//         .catch(error => {
//           if (
//               error.error.errorCode !== undefined &&
//               error.error.errorCode !== null &&
//               error.error.errorCode !== 'undefined'
//           ) {
//             if (error.error.errorCode === ErrorsEnum.ADMIN_NOT_FOUND) {
//               this._notificationsService.showInternalErrorMessage(
//                   'toast.admin.admin',
//                   'toast.admin.admin_not_found'
//               );
//             }
//           } else {
//             this._notificationsService.showHttpErrorMessage('Admin', error);
//           }

//           return Observable.throw(false);
//         });
//   }

//   public getAdminTypes(): Observable<Array<IGetAdminTypesResponse>> {
//     const command = new GetAdminTypesCommand();

//     return this._connectionService
//         .Request(command)
//         .map(data => {
//           return data;
//         })
//         .catch(() => {
//           return Observable.throw(false);
//         });
//   }

//   public getTravelsCurrentStatus(): Observable<TravelsCurrentStatus> {
//     const command = new GetTravelsCurrentStatusCommand();
//     command.setParameters(<IGetCarrierPreferenceCommandParameters>{
//       carrierUserId: this._identityService.userId
//     });
//     return this._connectionService
//         .Request(command)
//         .map(response => {
//           return response;
//         })
//         .catch(error => {
//           this._notificationsService.showHttpErrorMessage(
//               this.titleMessage,
//               error
//           );
//           return Observable.throw(false);
//         });
//   }


  public getStatisticsDashboardAdminsList(
      selectedCarrier: string,
      selectedCountry: string,
      selectedProvince: string,
      selectedYear: string,
      selectedMonth: number,
      dateFrom: string,
      dateTo: string): Observable<IGetDashboardCommandResponse> {

    const command = new GetDashboardAdminCommand();
    command.setParameters(<IGetDashboardAdminCommandParameters>{
      carrier: selectedCarrier,
      country: selectedCountry,
      province: selectedProvince,
      year: selectedYear,
      month: selectedMonth,
      dateFrom: dateFrom,
      dateTo: dateTo
    });

    return this._connectionService
        .Request(command)
        .pipe(
            map(data => {
                const response = data as IGetDashboardCommandResponse;
                return response;
            }),
            catchError(() => {
                return throwError(() => new Error('Operación fallida'));
            })
        );
  }

//   public resendSolicitude(adminId: Number) {
//     let command = new AdminResendSolicitudeCommand();
//     const params: IAdminResendSolicitudeParameters = {
//       adminId: adminId
//     };
//     command.setParameters(params);
//     return this._connectionService
//         .Request(command)
//         .map(data => {
//           this._notificationsService.showSuccessMessage(
//               'toast.clients.title',
//               'toast.general.resend_email_success'
//           );
//           return true;
//         })
//         .catch(error => {

//           this._notificationsService.showInternalErrorMessage(
//               'toast.clients.title',
//               'toast.general.resend_email_error'
//           );

//           return Observable.throw(false);
//         });
//   }

}
